import { render, staticRenderFns } from "./FeaturedChallengeLarge.vue?vue&type=template&id=bdefa62c&scoped=true&lang=pug&"
import script from "./FeaturedChallengeLarge.vue?vue&type=script&lang=js&"
export * from "./FeaturedChallengeLarge.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedChallengeLarge.vue?vue&type=style&index=0&id=bdefa62c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdefa62c",
  null
  
)

export default component.exports